import { render, staticRenderFns } from "./OptionServiceModal.vue?vue&type=template&id=01b2a4b8"
import script from "./OptionServiceModal.vue?vue&type=script&lang=js"
export * from "./OptionServiceModal.vue?vue&type=script&lang=js"
import style0 from "./OptionServiceModal.vue?vue&type=style&index=0&id=01b2a4b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports